<div class="p-2" *ngIf="fieldTypeSpecs">
  <div class="d-flex align-items-center mb-3">
    <div class="min-max text-end">
      <span class="fs-11 fw-bold">MIN VALUE:</span>
    </div>
    <div class="value">
      <input
        type="number"
        class="form-control"
        [(ngModel)]="fieldTypeSpecs.minValue"
        (ngModelChange)="onMinValueChange($event)" />
    </div>
    <div class="label">
      <input
        type="text"
        class="form-control"
        [(ngModel)]="fieldTypeSpecs.minLabel"
        (ngModelChange)="onMinLabelChange($event)" />
    </div>
  </div>
  <div class="d-flex align-items-center">
    <div class="min-max text-end">
      <span class="fs-11 fw-bold">MAX VALUE:</span>
    </div>
    <div class="value">
      <input
        type="number"
        class="form-control"
        [(ngModel)]="fieldTypeSpecs.maxValue"
        (ngModelChange)="onMaxValueChange($event)" />
    </div>
    <div class="label">
      <input
        type="text"
        class="form-control"
        [(ngModel)]="fieldTypeSpecs.maxLabel"
        (ngModelChange)="onMaxLabelChange($event)" />
    </div>
  </div>

  <div class="d-flex align-items-center mt-3">
    <div class="min-max"></div>
    <div class="fs-14 ps-2">
      Max must be at least 1 more than min, and no more than 10
    </div>
  </div>
</div>
